import React from "react"
import { DividerLinesContainer } from "./style"

const DividerLines = margin => {
  return <DividerLinesContainer margin={margin.margin} />
}

export default DividerLines
